import { makeStyles } from 'transfix-ui/core'
import { theme } from 'transfix-ui/theme'

export const useSavedLanesSectionStyles = makeStyles(() => ({
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: '0 0 100%',

    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
      flex: '0 1 auto',
    },
  },
}))
